import type { LandingPageContent } from '../types'

export const MONTAZ_PANELI_FOTOWOLTAICZNYCH: LandingPageContent = {
  slug: 'montaz-paneli-fotowoltaicznych',
  lang: 'pl',
  topicId: 'pv-module-montage',
  title: 'Montaż paneli fotowoltaicznych – bez kompletnego systemu',
  metaDescription:
    'Masz już panele fotowoltaiczne? Zapytaj wyłącznie o montaż na dachu - firmy składają ' +
    'niewiążące oferty, Ty porównujesz bezpłatnie.',
  keywords: [
    'montaż paneli fotowoltaicznych',
    'cena montażu paneli słonecznych',
    'montaż na dachu fotowoltaika',
    'montaż paneli bez materiału',
    'firma do montażu paneli słonecznych',
    'repowering fotowoltaiki',
    'wymiana starych paneli na nowe',
    'rozbudowa instalacji fotowoltaicznej',
    'dodatkowe panele fotowoltaiczne',
  ],
  eyebrow: 'Tylko montaż, bez pełnego pakietu',
  h1: 'Montaż paneli fotowoltaicznych – także bez kompletnego systemu',
  intro:
    'Nie każdy potrzebuje pełnego pakietu: niektórzy mają już kupione panele albo chcą zdobyć je sami ' +
    'i szukają tylko firmy rzemieślniczej do fachowego montażu na dachu. Właśnie do tego służy w ' +
    'Roofora osobny typ zapytania - "montaż na dachu" zamiast "kompletny system z montażem/' +
    'instalacją".',
  sections: [
    { type: 'heading', text: 'Dla kogo opłaca się zapytanie tylko o montaż na dachu' },
    {
      type: 'list',
      items: [
        'Masz już kupione panele (np. od innego dostawcy) i potrzebujesz tylko montażu',
        'Chcesz sam zdobyć materiał, aby zaoszczędzić lub użyć konkretnej marki',
        'Planujesz rozbudowę istniejącej instalacji i potrzebujesz tylko dodatkowej pracy rzemieślniczej',
      ],
    },
    { type: 'heading', text: 'Kto dostarcza materiał?' },
    {
      type: 'paragraph',
      text:
        'Sam decydujesz przy składaniu zapytania, czy dostarczasz materiał montażowy, czy ma go ' +
        'zdobyć firma rzemieślnicza - obie opcje są możliwe, po prostu zaznaczasz to w zapytaniu.',
    },
    { type: 'heading', text: 'Tak przebiega zapytanie o montaż na dachu' },
    {
      type: 'paragraph',
      text:
        'Podobnie jak przy pełnym zapytaniu, składasz anonimowe zapytanie ze zdjęciami dachu, ' +
        'orientacją i pożądaną liczbą paneli lub wielkością instalacji. Firmy rzemieślnicze w Twoim ' +
        'regionie widzą zapytanie i składają niewiążące oferty tylko na usługę montażu - nie ma ' +
        'potrzeby analizy zużycia ani opłacalności, ponieważ konfigurację instalacji już znasz.',
    },
    { type: 'heading', text: 'Kontakt dopiero po Twojej zgodzie' },
    {
      type: 'paragraph',
      text:
        'Także przy zapytaniach tylko o montaż obowiązuje ta sama zasada co w całej Roofora: kontakt ' +
        'nawiązywany jest dopiero wtedy, gdy indywidualnie zgodzisz się na konkretną firmę rzemieślniczą ' +
        '- bez zbiorowej zgody, bez lawiny telefonów.',
    },
    { type: 'heading', text: 'Istniejąca instalacja: repowering i rozbudowa' },
    {
      type: 'paragraph',
      text:
        'Dwa częste powody zapytania tylko o montaż nie dotyczą nowej instalacji, lecz już istniejącej: ' +
        'repowering (wymiana starych paneli słonecznych na nowe, wydajniejsze) oraz rozbudowa o ' +
        'dodatkowe panele. W obu przypadkach po prostu zaznacz "materiał od klienta" i sam przynieś ' +
        'nowe panele - firma rzemieślnicza zajmuje się wyłącznie fachowym montażem lub wymianą, bez ' +
        'konieczności ponownego wystawiania na przetarg całego systemu.',
    },
    {
      type: 'paragraph',
      text:
        'Kontekst prawny w Niemczech (informacja zewnętrzna, nie jest to porada prawna): od Solarpaket ' +
        'I (kwiecień 2024) wymiana starych paneli na nowe, wydajniejsze w instalacjach dachowych stała ' +
        'się prostsza - dotychczasowa taryfa gwarantowana (EEG) dla pierwotnie zainstalowanej mocy z ' +
        'reguły zostaje zachowana, o ile nowa instalacja nie przekracza mocy poprzedniej. Szczegóły ' +
        'dotyczące Twojego przypadku sprawdź bezpośrednio u swojego operatora sieci lub właściwej ' +
        'instytucji przed planowaniem.',
    },
  ],
  faq: [
    {
      q: 'Czy mogę dowolnie wybrać typ panelu i producenta, jeśli sam dostarczam materiał?',
      a: 'Tak - przy opcji "materiał od klienta" przynosisz panele według własnego wyboru, a firma rzemieślnicza zajmuje się wyłącznie fachowym montażem.',
    },
    {
      q: 'Co, jeśli nie mam jeszcze kompletnego systemu, tylko dopiero planuję?',
      a: 'Wtedy zwykle lepiej pasuje typ zapytania "kompletny system z montażem/instalacją", który automatycznie oblicza odpowiednią konfigurację. Zapytanie tylko o montaż jest dla osób, które już znają wielkość swojej instalacji.',
    },
    {
      q: 'Mój panel słoneczny jest uszkodzony - czy mogę to załatwić przez Roofora?',
      a: 'To zależy, o co chodzi. W sprawie gwarancji Twoim partnerem jest firma rzemieślnicza, która pierwotnie zainstalowała instalację - Roofora tego nie obsługuje. Jeśli natomiast chcesz po prostu wymienić uszkodzony panel na nowy (np. bo pierwotna firma już nie działa lub chcesz uzyskać nową ofertę), pasuje to jako zwykłe zapytanie o montaż na dachu.',
    },
  ],
  primaryCta: { label: 'Złóż zapytanie o montaż na dachu', action: 'customer' },
  secondaryCta: { label: 'Potrzebujesz tylko instalacji elektrycznej?', action: 'link', href: '/instalacja-elektryczna-fotowoltaiki' },
  relatedLinks: [
    { label: 'Znajdź instalatora fotowoltaiki', href: '/znajdz-instalatora-fotowoltaiki' },
    { label: 'Jak działa porównanie ofert', href: '/porownaj-oferty-fotowoltaiczne' },
    { label: 'Zaplanuj instalację krok po kroku', href: '/zaplanuj-instalacje-fotowoltaiczna' },
  ],
}
